module.exports = __webpack_public_path__ + "img/swisspass.457ca795.svg";